import React from 'react';
import RichTextDisplay from '../../components/RichTextDisplay';

const RetailRichTextDescription = ({ content, className = '' }) => (
  <div className={`retail-product-description max-h-12 overflow-hidden text-sm leading-5 text-gray-600 ${className}`.trim()}>
    <RichTextDisplay
      content={content || '<p>-</p>'}
      sx={{ fontSize: '14px', lineHeight: 1.35, color: '#4b5563' }}
    />
  </div>
);

export default RetailRichTextDescription;
